import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'feature-app-loading-dialog',
  standalone: true,
  imports : [
    MatProgressSpinnerModule
  ],
  template: `
    <div class="tw-p-[20px] tw-flex tw-items-center tw-gap-[16px]">
      <mat-spinner diameter="20"></mat-spinner>
      <span class="tw-text-[12px]">{{ data.message }}</span>
    </div>
  `,
})
export class LoadingDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}
